<template>
  <div>
    <vx-card>
      <div slot="no-body" class="tabs-container px-6 pt-6 minus-top">
        <div class="tab-text">
          <div class="vx-row">
            <div class="vx-col md:w-1/3 w-full mt-2">

              <vs-input
                v-validate="'required|min:3'"
                data-vv-validate-on="blur"
                type="account"
                name="fullName"
                :label="$t('accountUser.fullName')"
                v-model="user.fullName"
                autocomplete="off"
                class="w-full"/>
              <span class="text-danger text-sm">{{
                  errors.first("fullName")
                }}</span>

            </div>
            <!-- <div class="vx-col md:w-1/3 w-full mt-2">
              <vs-input
                v-validate="'required|min:3'"
                data-vv-validate-on="blur"
                type="text"
                name="organizationName"
                label="Tên tổ chức"
                v-model="user.organizationName"
                autocomplete="off"
                class="w-full"/>
              <span class="text-danger text-sm">{{
                errors.first("organizationName")
              }}</span>
            </div> -->
            <div class="vx-col md:w-1/3 w-full mt-2">
              <vs-input

                type="email"
                name="email"
                label="Email"
                v-model="user.email"
                autocomplete="off"
                class="w-full"/>
              <span class="text-danger text-sm">{{
                  errors.first("email")
                }}</span>
            </div>
          </div>
          <div class="vx-row">

            <div class="vx-col md:w-1/3 w-full mt-2">
              <vs-input
                v-validate="'required|numeric|min:10|max:11'"
                data-vv-validate-on="blur"
                type="text"
                name="phoneNumber"
                :label="$t('accountUser.phoneNum')"
                v-model="user.phoneNumber"
                autocomplete="off"
                class="w-full"/>
              <span class="text-danger text-sm">{{
                  errors.first("phoneNumber")
                }}</span>
            </div>
            <div class="vx-col md:w-1/3 w-full mt-2">
              <label class="vs-input--label">{{$t('accountUser.sex')}}</label>
              <v-select
                class=""
                v-model="genderModel"
                :clearable="false"
                :options="genderOptions"
                data-vv-validate-on="input"
                v-validate="'required'"
                name="gender"/>
              <span class="text-danger text-sm">{{
                  errors.first("gender")
                }}</span>
            </div>
            <div class="vx-col md:w-1/3 w-full mt-2">
              <label class="vs-input--label">{{$t('accountUser.birthday')}}</label>
              <datepicker :format="'dd/MM/yyyy'" v-model="user.birthday"
                          data-vv-validate-on="input" v-validate="''" name="birthday"></datepicker>
              <span class="text-danger text-sm">{{ errors.first('birthday') }}</span>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/3 w-full mt-2">
              <label class="vs-input--label">{{$t('accountUser.statusUser')}}</label>
              <v-select
                v-model="activeStatusModel"
                :clearable="false"
                :options="activeStatusOptions"
                data-vv-validate-on="input"
                v-validate="'required'"
                name="activeStatus"/>
              <span class="text-danger text-sm">{{
                  errors.first("activeStatus")
                }}</span>
            </div>

            <div class="vx-col md:w-1/3 w-full mt-2">
              <vx-input-group class="mb-base">
                <vs-input
                  v-validate="isUpdate ? { is: user.rePassword, min:6 } : {is: user.rePassword, min: 6}"
                  data-vv-validate-on="blur"
                  type="text"
                  name="password"
                  :label="$t('accountUser.passUser')"
                  v-model="user.rePassword"
                  autocomplete="off"
                  class="w-full"/>
                <span class="text-danger text-sm">
                {{errors.first("password")}}</span>
                <template slot="append" >
                  <div class="append-text btn-addon" style="height: 38px;margin-top: 21px;">
                    <vs-button color="success" class="g-btn" @click="onGenerate">Generate</vs-button>
                  </div>
                </template>
              </vx-input-group>
            </div>
            <div class="vx-col md:w-1/3 w-full mt-2">
              <vs-input
                v-validate="isUpdate ? { is: user.rePassword, min:6 } : {required: true, is: user.rePassword, min: 6}"
                data-vv-validate-on="blur"
                type="text"
                name="rePassword"
                :label="$t('accountUser.confirmPass')"
                v-model="user.password"
                autocomplete="off"
                class="w-full"/>
              <span class="text-danger text-sm">{{
                  errors.first("rePassword")
                }}</span>
            </div>
          </div>
          <div class="vx-row">

          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/4 w-full mt-2">
              <label class="vs-input--label">{{$t('accountUser.city')}}</label>
              <v-select
                height="140px"
                :dense="true"
                v-model="province"
                :clearable="false"
                :options="cityOptions"
                data-vv-validate-on="input"
                v-validate="''"
                name="city"
              />
              <span class="text-danger text-sm">{{
                  errors.first("city")
                }}</span>
            </div>
            <div class="vx-col md:w-1/4 w-full mt-2">
              <label class="vs-input--label">{{$t('accountUser.district')}}</label>
              <v-select
                class=""
                v-model="district"
                :clearable="false"
                :options="districtOptions"
                data-vv-validate-on="blur"
                v-validate="''"
                name="district">
                <span slot="no-options">
                  {{$t('accountUser.spanNoOption')}}
                </span>
              </v-select>
              <span class="text-danger text-sm">{{
                  errors.first("district")
                }}</span>
            </div>
            <div class="vx-col md:w-1/4 w-full mt-2">
              <label class="vs-input--label">{{$t('accountUser.subDistrict')}}</label>
              <v-select
                class=""
                v-model="subDistrict"
                :clearable="false"
                :options="subDistrictOptions"
                data-vv-validate-on="blur"
                v-validate="''"
                name="subDistrict"
              />
              <span class="text-danger text-sm">{{
                  errors.first("subDistrict")
                }}</span>
            </div>
            <div class="vx-col md:w-1/4 w-full mt-2">
              <vs-input
                class="w-full"
                :label="$t('accountUser.houseNumber')"
                v-model="user.houseNumber"
                v-validate="''"
                name="houseNumber"/>
              <span class="text-danger text-sm">{{
                  errors.first("houseNumber")
                }}</span>
            </div>
          </div>

          <div class="vx-row">

          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-2">
              <vs-input
                class="w-full"
                :label="$t('accountUser.address')"
                v-model="fullAddressModel"
                v-validate="''"
                name="full_address"
                readonly="true"/>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-4 mb-4 flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto mt-2 text-size" @click="saveChanges" :disabled="!validateForm">{{`${isUpdate ?
                  $t('accountUser.updateUser'): $t('accountUser.createUser')}`}}
                </vs-button>
                <vs-button class="ml-4 mt-2 text-size" type="border" color="warning" @click="$router.go(-1)">{{ $t('accountUser.backUser') }}
                </vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>

</template>
<script>

import vSelect from 'vue-select'
import province from '@/assets/utils/province.js';
import Datepicker from '@/components/datepicker/Datepicker.vue';
export default {
  data() {
    return {
      characters: [
        {
          name: "Lowercase",
          value: "abcdefghijklmnopqrstuvwxyz",
          checked: false,
        },
        {
          name: "Uppercase",
          value: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
          checked: true,
        },
        {
          name: "Numbers",
          value: "0123456789",
          checked: true,
        },
        {
          name: "Special Characters",
          value: "_-+=)(*&^%$#@!`~",
          checked: false,
        },
      ],
      password: "",
      gLength: 9,
      isUpdate: false,
      id: null,
      registerSuccess: 0,
      genderOptions: [
        {value: 0, label: this.$t('accountUser.otherUser')},
        {value: 1, label: this.$t('accountUser.male')},
        {value: 2, label: this.$t('accountUser.female')}
      ],
      activeStatusOptions: [
        {value: 0, label: this.$t('accountUser.unActiveUsers')},
        {value: 1, label: this.$t('accountUser.activeUsers')},
        {value: 2, label: this.$t('accountUser.lockUser')}
      ],
      cityOptions: province.getProvince(),
      districtOptions: province.getDistrict(),
      subDistrictOptions: province.getSubDistrict(),
      user: {
        password: "",
        gender: null,
        city: null,
        district: null,
        subDistrict: null,
        address: null,
        houseNumber: null,
        rePassword: "",
        activeStatus: 0,
        organizationName:null
      },
    };
  },
  components: {
    vSelect,
    Datepicker
  },
  computed: {
    validateForm() {
      return !this.errors.any();
    },
    genderModel: {
      get() {
        let obj = this.genderOptions.find(x => x.value === this.user.gender);
        if (!obj) {
          return null;
        }
        return {
          label: obj.label,
          value: this.user.gender
        }
      },
      set(obj) {
        this.user.gender = obj.value;
      }
    },
    activeStatusModel: {
      get() {
        let obj = this.activeStatusOptions.find(x => x.value === this.user.activeStatus);
        if (!obj) {
          return null;
        }
        return {
          label: obj.label,
          value: this.user.activeStatus
        }
      },
      set(obj) {
        this.user.activeStatus = obj.value;
      }
    },
    province: {
      get() {
        let obj = this.cityOptions.find(x => x.value === this.user.city);
        if (!obj) {
          return null;
        }
        return {
          label: obj.label,
          value: this.user.city
        }
      },
      set(obj) {
        this.user.city = obj.value;
        this.districtOptions = province.getDistrict(obj.value);
        this.user.district = this.districtOptions[0].value;
        this.subDistrictOptions = province.getSubDistrict(this.user.city, this.user.district);
        this.user.subDistrict = this.subDistrictOptions[0].value;
      }
    },
    district: {
      get() {
        let obj = this.districtOptions.find(x => x.value === this.user.district);
        if (!obj) {
          return null;
        }
        return {
          label: obj.label,
          value: this.user.district
        }
      },
      set(obj) {
        this.user.district = obj.value;
        this.subDistrictOptions = province.getSubDistrict(this.user.city, obj.value);
        this.user.subDistrict = this.subDistrictOptions[0].value;
      }
    },
    subDistrict: {
      get() {
        let obj = this.subDistrictOptions.find(x => x.value === this.user.subDistrict);
        if (!obj) {
          return null;
        }
        return {
          label: obj.label,
          value: this.user.subDistrict
        }
      },
      set(obj) {
        this.user.subDistrict = obj.value
      }
    },
    fullAddressModel: {
      get() {
        let houseNumber = `${this.user.houseNumber ? this.user.houseNumber + ', ' : ''}`
        let subDistrict = `${this.subDistrict && this.subDistrict.label ? this.subDistrict.label + ', ' : ''}`
        let district = `${this.district && this.district.label ? this.district.label + ", " : ''}`
        let province = `${this.province && this.province.label ? this.province.label: ''}`;
        /* eslint-disable */
        this.user.fullAddress = houseNumber + subDistrict + district + province;
        return this.user.fullAddress;
      },
    }
  },
  created() {
    this.userId = this.$route.query.id;
    if (this.userId) {
      this.$vs.loading();
      this.$oauth.post('/user/find-by-condition/' + this.userId).then((response) => {
        this.$vs.loading.close();
        this.districtOptions = province.getDistrict(response.data.city);
        this.subDistrictOptions = province.getSubDistrict(response.data.city, response.data.district);
        response.data.organizationName = response.data.organization ? response.data.organization.organizationName : "";
        this.user = response.data;
        this.isUpdate = true;
      }).catch((err) => {
        this.$vs.loading.close();
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      });
    }
  },
  methods: {
    onGenerate() {
      let result = "";
      let charactersVal = "";
      for (let j = 0; j < this.characters.length; j++) {
        if (this.characters[j].checked) {
          charactersVal += this.characters[j].value;
        }
      }
      for (let i = 0; i < this.gLength; i++) {
        result += charactersVal.charAt(Math.floor(Math.random() * charactersVal.length));
      }
      this.user.password = result;
      this.user.rePassword = result;
    },
    getLabelString(object) {
      return (object && object.label);
    },
    changeGender () {
      this.$validator.validateAll()
    },
    async saveChanges(evt) {

      evt.preventDefault();
      if (!this.validateForm) return;

      const result = await this.$validator.validateAll();
      if (!result) return;
      let path = this.isUpdate ? ('/user/update') : '/user/create';
      this.$vs.loading();
      const details = localStorage.getItem('userInfo');
      const user = JSON.parse(details);
      if(!this.isUpdate){
        this.user.organizationName = user.organization.organizationName;
        this.user.organizationId = user.organization.id;
        this.user.customerType = user.customerType
      }
      else{
        this.user.organizationId = this.user.organization ? this.user.organization.id : null;
      }
      this.$oauth.post(path, this.user).then((response) => {
        this.$vs.loading.close();
        this.$vs.notify({
          color: 'primary',
          text: `${this.isUpdate ? this.$t('accountUser.btnUpdate') : this.$t('accountUser.btnAdd') } ` +  ` ${this.$t('accountUser.textSuccess') }`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
        });
        this.$router.push('/user/group-account-v2').catch(() => {
        })
      }).catch((err) => {
        this.$vs.loading.close();
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      });
    },
  }
};
</script>
<style>
.title-size{
  font-size: 16px !important;
}
.text-size{
  font-size: 12px !important;
}
.minus-top{
  margin-top: -24px;
}
</style>
